import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type OrbitLTerminalSearchResultDto,
  getMerchantsOrbitLTerminals,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ORBIT_L_TERMINAL_SEARCH_QUERY_KEY = "ORBIT_L_TERMINAL_SEARCH";

export const orbitLTerminalSearchKeys = {
  all: [ORBIT_L_TERMINAL_SEARCH_QUERY_KEY],
  bySearch: (search?: string) => [...orbitLTerminalSearchKeys.all, search],
};

type SearchParams = {
  search?: string;
  enabled?: boolean;
};

export const useSearchOrbitLTerminalsQuery = ({
  search,
  enabled = true,
}: SearchParams) =>
  useQuery<Array<OrbitLTerminalSearchResultDto>>({
    queryKey: orbitLTerminalSearchKeys.bySearch(search),
    queryFn:
      enabled && search != null
        ? processResponseWithApiProblemDetails(() =>
            getMerchantsOrbitLTerminals(search),
          )
        : skipToken,
  });
